import
{
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
} from "@angular/core";
import { Address, Cart, CartUpdateDTO } from "@dto";
import { CartService } from "@service/cart/cart.service";
import { showAfterSecond } from "../../../../../utils/utilsFunctions";

@Component({
    selector: "app-address-popup",
    templateUrl: "./address-popup.component.html",
    styleUrls: ["./address-popup.component.scss"],
    standalone: false
})
export class AddressPopupComponent
{
  private isLoading: boolean = false;
  public showForm: boolean = false;
  public loaded = [];

  constructor(
    private cartService: CartService,
    private changeDet: ChangeDetectorRef
  ) { }

  @Input() public title: string;
  @Input() public description: string;
  @Input() public width: number = 400;
  @Input() public height: number = 254;
  @Input() public autoSize: boolean = false;
  @Input() public show: boolean = false;
  @Input() public deliveryPostCode: string;

  openModal(): void
  {
    this.showForm = true;
    showAfterSecond(100, this.loaded, this.changeDet);
    this.changeDet.detectChanges();
  }

  public saveDeliveryPostCode(): void
  {
    // todo: service && animacja przycisku
    this.isLoading = true;
    const cartUpdate: CartUpdateDTO = {
      deliveryAddress: {
        postCode: this.deliveryPostCode
      }

    };
    this.cartService.updateCart(cartUpdate).subscribe((cart: Cart) =>
    {
      this.isLoading = false;
      this.showForm = false;
    });
  }

  public closeModal(event?: any): void
  {
    if (!event || !event.path[0].className.includes("success-link"))
    {
      this.loaded["loaded"] = false;
      this.showForm = false;
      this.changeDet.detectChanges();
    }
  }

  @HostListener("window:keyup", ["$event"])
  private onKeyUp(event): void
  {
    if (this.showForm && (event.key === "Escape" || event.keyCode == 13))
    {
      this.saveDeliveryPostCode();
      this.closeModal(null);
    }
  }
}
